function isTruthyFlag(value) {
  return value === true || value === 1 || value === '1'
}

function isGongfaTimeoutTerminated(row) {
  const value = row || {}
  return isTruthyFlag(value.is_timeout_terminated) ||
    isTruthyFlag(value.timeout_terminated) ||
    isTruthyFlag(value.return_expired) ||
    Number(value.status) === 9
}

module.exports = {
  isGongfaTimeoutTerminated,
}
